module.exports = __webpack_public_path__ + "img/logo.36919a40.png";